<template>
	<div>
		<h1>Clés de sécurité</h1>
		<h3>Liste</h3>
		<b-input-group v-for="(credential, i) in credentials" :key="'c'+i">
			<template #prepend>
				<b-input-group-text><i v-if="!credential.client_user_uid" class="fas fa-users"></i><i v-else class="fas fa-user"></i>&nbsp;{{ credential.name }}</b-input-group-text>
			</template>
			<template #append>
                <b-button
					variant="outline-secondary"
                    @click="() => toggle_view_key(credential.uid, i)">
                    <i class="flex justify-center align-center" :class="credential.visible ? 'fas fa-eye' : 'fas fa-eye-slash'"></i>
                </b-button>

				<b-button
					:disabled="!credential.value.length"
					variant="outline-secondary"
					@click="update_key(credential.uid, credential.value)"
					>Modifier</b-button
				>
				<b-button
					variant="outline-secondary"
					@click="delete_key(credential.uid, credential.name)"
					>Supprimer</b-button
				>
			</template>
			<b-form-input
				:type="credential.visible ? 'text' : 'password'"
				v-model="credential.value"
				placeholder="Nouveau mot de passe"></b-form-input>
		</b-input-group>
		<br />
		<h3>Nouvelle clé</h3>
		<b-input-group prepend="Service">
			<b-form-input
				@change="change_service"
				v-model="service"
				placeholder="Service - prefix au nom"
				list="services"></b-form-input>
			<datalist id="services">
				<option v-for="service in services" :key="service">
					{{ service }}
				</option>
			</datalist>
		</b-input-group>
		<br />

		<b-input-group
			v-for="(new_credential, index) in new_credentials"
			:key="index">
			<template #prepend>
				<b-input-group-text>Clé / Valeur</b-input-group-text>
			</template>
			<template #append>
				<b-button
					variant="outline-secondary"
					@click="new_credentials.splice(index, 1)"
					>Supprimer</b-button
				>
			</template>
			<b-form-input
				placeholder="Nom - à mettre dans les scénarios"
				v-model="new_credential.name"></b-form-input>
			<b-form-input
				type="password"
				v-model="new_credential.value"
				placeholder="Mot de passe / valeur de la clée"></b-form-input>
		</b-input-group>

		<br />

		<b-button @click="new_credentials.push({ name: '', value: '' })"
			>Nouvelle clé</b-button
		>

		<br /><br />

		Portée : 

		<b-button @click="new_credentials_user = false" :variant="!new_credentials_user ? 'success' : 'secondary' "><i class="fas fa-users" /> Client</b-button>&nbsp;
		<b-button @click="new_credentials_user = true" :variant="new_credentials_user ? 'success' : 'secondary' "><i class="fas fa-user" /> Utiilsateur</b-button>

		<br /><br />

		<b-button @click="save_key">Enregistrer</b-button>
	</div>
</template>

<script>
	import store from "../store";
	import credentials from "../services/credentials";

	export default {
		name: "credentials",
		components: {},
		data() {
			return {
				new_credentials_user: false,
				credentials: [],
				new_credentials: [{ name: "", value: "", visible: false }],
				key: "",
				password: "",

				service: "",
				services: ["ftp", "abbyy", "google", "airtable", "firecrawl", "chatgpt", "perplexity", "linkedin", "google_translate", "deepl", "mail"],

				services_credentials: {
					abbyy: [
						{ name: "id", value: "" },
						{ name: "pwd", value: "" },
					],
					ftp: [
						{ name: "host", value: "" },
						{ name: "user", value: "" },
						{ name: "pwd", value: "" },
						{ name: "port", value: "" },
					],
					google: [{ name: "key" }],
                    airtable: [
                        { name: "API_KEY", value: "" },
                        { name: "APP_ID", value: "" },
                    ],
                    firecrawl: [
                        { name: "key", value: "" },
                    ],
                    chatgpt: [
                        { name: "key", value: "" },
                    ],
                    perplexity: [
                        { name: "key", value: "" },
                    ],
                    linkedin: [
                        { name: "key", value: "" },
                    ],
                    google_translate: [
                        { name: "api_key", value: "" },
                    ],
                    deepl: [
                        { name: "api_key", value: "" },
                        { name: "url", value: "" },
                    ],
                    mail: [
                        { name: "host", value: "" },
                        { name: "login", value: "" },
                        { name: "pwd", value: "" },
                    ],
				},
			};
		},
		methods: {
            toggle_view_key: async function(uid, credentialIndex) {
                var currentCredential = this.credentials[credentialIndex];
                if (currentCredential.visible) {
                    currentCredential.visible = false;
                } else {
                    if (currentCredential.value.length === 0) {
                        let decrypted = await credentials.getOne(uid);
                        currentCredential.value = decrypted.value;
                    }
                    currentCredential.visible = true;
                }
                this.$forceUpdate(); 
            },
			change_service: async function () {
				console.log(this.service);
				if (this.services_credentials[this.service])
					this.new_credentials =
						this.services_credentials[this.service];
			},
			save_key: async function () {
				for (var i = 0; i < this.new_credentials.length; i++) {
					var name = this.new_credentials[i].name;
					if (this.service) name = this.service + "_" + name;
					console.log(name);
					await credentials.post(name, this.new_credentials[i].value, this.new_credentials_user);
				}
				this.new_credentials = [{ name: "", value: "" }];
				this.service = "";
				this.credentials = await credentials.getAll();
			},
			delete_key: async function (uid, name) {
				var self = this;

				this.$fire({
					title: "Etes vous sûr de vouloir supprimer " + name + "?",
					showCloseButton: true,
					showCancelButton: true,
					focusConfirm: false,
					confirmButtonText: "oui",
					cancelButtonText: "non",
				}).then(async (r) => {
					console.log(r);
					if (r.value) {
						await credentials.delete_key(uid);
						self.credentials = await credentials.getAll();
					}
				});
			},
			update_key: async function (uid, password) {
				await credentials.put(uid, password);
				this.credentials = await credentials.getAll();
			},
		},
		mounted: async function () {
			this.credentials = await credentials.getAll();

            for (let i = 0; i < this.credentials.length; i++) {
                this.credentials[i].visible = false;
            }

			if (store.state.user.rules && !store.state.user.rules.credentials) {
				this.$router.push({ name: "profile" });
			}
		},
	};
</script>

<style scoped>
	.input-group > .input-group-prepend {
		flex: 0 0 20%;
	}
	.input-group .input-group-text {
		width: 100%;
	}
</style>
